import assessment from '../../../assets/img/icons/assessment.png';
import approval from '../../../assets/img/icons/approval.png';
import PO1 from '../../../assets/img/icons/PO1.png';
import administrator from '../../../assets/img/icons/administrator2.png';
import key from '../../../assets/img/icons/key.png';
import ulockApp from '../../../assets/img/icons/ulockApp.png';
import enquiry from '../../../assets/img/icons/enquiry.png';
import reports from '../../../assets/img/icons/reports.png';
import SidebarEtd from '../../../shared/components/SidebarEtd';
import HeaderEtd from '../../../shared/components/HeaderEtd';
import { Link } from "react-router-dom";
import { getLoginInfo, getRefreshToken } from '../../../shared/utils/storage';
import { useEffect } from "react";
import Lindo from '../../../app/guards/RouteGuard';

function EtdDashboard() {
  const { isLoading, mgambo } = Lindo();
  const rolesData = getLoginInfo()?.user?.Roles || "[]";
  // Parse roles if it's a string, otherwise use as is
  let roles = [];
  try {
    roles = typeof rolesData === "string" ? JSON.parse(rolesData) : rolesData;
  } catch (error) {
    console.error("Error parsing roles:", error);
    roles = [];
  }

  // Helper function to check if user has a specific role
  const hasRole = (roleCode) => {
    return (
      Array.isArray(roles) && roles.some((role) => role.RoleCode === roleCode)
    );
  };

  // Helper function to check if user has any of the specified role IDs
  const hasRoleID = (...roleIDs) => {
    return (
      Array.isArray(roles) &&
      roles.some((role) => roleIDs.includes(role.RoleID))
    );
  };

  // Check for admin privileges (RoleID 1 or 2)
  const isAdmin = hasRoleID(1, 2);

  useEffect(() => {
    mgambo("MbaoNdogo");
  }, []);

  return (
    <>
      <HeaderEtd />
      <div className="">
        <div className="wrapper">
          <SidebarEtd />
          <div className="main-panel">
            <div className="content2">
              <div className="container-fluid">
                <h2 style={{ color: "#c2c2c2" }}>
                  <i>ETD Dashboard</i>
                </h2>
                <div className="row">
                  {hasRole("ETD_assessor") || hasRole("ETD_administrator") ? (
                    <div
                      className="col-lg-3 col-md-6 col-sm-6"
                      style={{ marginTop: "20px" }}
                    >
                      <Link to="/assessment">
                        <div className="card-header card-header-warning card-header-icon">
                          <center>
                            <div className="card-icon">
                              <img
                                src={assessment}
                                alt="assessment"
                                width="120px"
                              />
                            </div>
                          </center>
                          <center>
                            <h3 className="card-title">Assessment</h3>
                          </center>
                        </div>
                      </Link>
                    </div>
                  ) : null}

                  {hasRole("ETD_Approval") || hasRole("ETD_administrator") ? (
                    <div
                      className="col-lg-3 col-md-6 col-sm-6"
                      style={{ marginTop: "20px" }}
                    >
                      <Link to="/approval">
                        <div className="card-header card-header-success card-header-icon">
                          <center>
                            <div className="card-icon">
                              <img
                                src={approval}
                                alt="approval"
                                width="120px"
                              />
                            </div>
                          </center>
                          <center>
                            <h3 className="card-title">Approval/PO</h3>
                          </center>
                        </div>
                      </Link>
                    </div>
                  ) : null}

                  {hasRole("ETD_Manager") || hasRole("ETD_administrator") ? (
                    <div
                      className="col-lg-3 col-md-6 col-sm-6"
                      style={{ marginTop: "20px" }}
                    >
                      <Link to="/po1">
                        <div className="card-header card-header-warning card-header-icon">
                          <center>
                            <div className="card-icon">
                              <img src={PO1} alt="PO1" width="120px" />
                            </div>
                          </center>
                          <center>
                            <h3 className="card-title">PO1</h3>
                          </center>
                        </div>
                      </Link>
                    </div>
                  ) : null}
                  <br />
                  {/* {Roles?.ETDApproval || Roles?.ETDManager || Roles?.GroupName == "Super Admin" ? ( */}
                  <div
                    className="col-lg-3 col-md-6 col-sm-6"
                    style={{ marginTop: "20px" }}
                  >
                    <Link to="/reports">
                      <div className="card-header card-header-info card-header-icon">
                        <center>
                          <div className="card-icon">
                            <img src={reports} alt="account" width="120px" />
                          </div>
                        </center>
                        <center>
                          <h3 className="card-title">Reports</h3>
                        </center>
                      </div>
                    </Link>
                  </div>
                  {/* ) : null} */}

                  {/* {Roles?.data[0]?.Accountant == 1 || Roles?.data[0]?.PRIVILEGEID == 1 || Roles?.data[0]?.PRIVILEGEID == 2 ? (
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <Link to="/accountant">
                        <div className="card-header card-header-info card-header-icon">
                          <center>
                            <div className="card-icon">
                              <img src={account} alt="account" width="120px" />
                            </div>
                          </center>
                          <center>
                            <h3 className="card-title">Accountant</h3>
                          </center>
                        </div>
                      </Link>
                    </div>
                  ) : null} */}

                  <div
                    className="col-lg-3 col-md-6 col-sm-6"
                    style={{ marginTop: "20px" }}
                  >
                    <Link to="/enquiry">
                      <div className="card-header card-header-info card-header-icon">
                        <center>
                          <div className="card-icon">
                            <img
                              src={enquiry}
                              alt="userManagement"
                              width="120px"
                            />
                          </div>
                        </center>
                        <center>
                          <h3 className="card-title">Enquiry</h3>
                        </center>
                      </div>
                    </Link>
                  </div>

                  {/* {isAdmin ? (
                    <div
                      className="col-lg-3 col-md-6 col-sm-6"
                      style={{ marginTop: "20px" }}
                    >
                      <Link to="/globaladmin">
                        <div className="card-header card-header-success card-header-icon">
                          <center>
                            <div className="card-icon">
                              <img
                                src={administrator}
                                alt="administrator"
                                width="120px"
                              />
                            </div>
                          </center>
                          <center>
                            <h3 className="card-title">ETD Admin</h3>
                          </center>
                        </div>
                      </Link>
                    </div>
                  ) : null} */}
                  {hasRole("ETD_administrator") ||
                  hasRole("ETD_STATION_ADMIN") ? (
                    <div
                      className="col-lg-3 col-md-6 col-sm-6"
                      style={{ marginTop: "20px" }}
                    >
                      <Link to="/unlockApp">
                        <div className="card-header card-header-success card-header-icon">
                          <center>
                            <div className="card-icon">
                              <img
                                src={ulockApp}
                                alt="registry"
                                width="120px"
                              />
                            </div>
                          </center>
                          <center>
                            <h3 className="card-title">Unlock App</h3>
                          </center>
                        </div>
                      </Link>
                    </div>
                  ) : null}
                  {hasRole("ETD_administrator") ||
                  hasRole("ETD_STATION_ADMIN") ? (
                    <div
                      className="col-lg-3 col-md-6 col-sm-6"
                      style={{ marginTop: "20px" }}
                    >
                      <Link to="/unlockDoc">
                        <div className="card-header card-header-success card-header-icon">
                          <center>
                            <div className="card-icon">
                              <img src={key} alt="unlock" width="120px" />
                            </div>
                          </center>
                          <center>
                            <h3 className="card-title">Unlock doc</h3>
                          </center>
                        </div>
                      </Link>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EtdDashboard;
